export enum Permission {
  ClassroomAdmin = "classroom_admin",
  ClassroomTechManager = "classroom_ed-tech",
  CloudOnlyFilterAdmin = "surfwize_cloud_filter_admin",
  CloudDNSFilterAdmin = "surfwize_cloud_dns_filter_admin",
  CommunityAdmin = "community_admin",
  ConfigurationAdmin = "surfwize_settings",
  FilteringReportingAdmin = "surfwize_admin",
  FilteringAdmin = "surfwize_filtering",
  GuestConfiguration = "surfwize_guest_settings",
  NetworkAdmin = "edgewize",
  Owner = "owner",
  ReportingViewer = "surfwize_reporting",
}

/**
 * For detailed descriptions, refer to https://help.linewize.com/hc/en-gb/articles/5765505949852-User-Roles-in-Linewize-Filter
 */
export const PermissionLabels: { [key in Permission]: string } = Object.freeze({
  [Permission.ClassroomAdmin]: "Classroom Administrator",
  [Permission.ClassroomTechManager]: "Classroom Ed-Tech Manager",
  [Permission.CloudOnlyFilterAdmin]: "Cloud Only Filter Administrator",
  [Permission.CloudDNSFilterAdmin]: "Cloud DNS Filter Administrator",
  [Permission.CommunityAdmin]: "Community Administrator",
  [Permission.ConfigurationAdmin]: "Configuration Administrator",
  [Permission.FilteringReportingAdmin]: "Filtering/Reporting Administrator",
  [Permission.FilteringAdmin]: "Filtering Administrator",
  [Permission.GuestConfiguration]: "Guest Configuration",
  [Permission.NetworkAdmin]: "Wan and Firewall Administrator",
  [Permission.Owner]: "Owner/Global Administrator",
  [Permission.ReportingViewer]: "Reporting/Pastoral Care Administrator",
});

/**
 * Order must be considered when making changes to this list! Users may have a mix of
 * multiple roles in which case the first match in the list will be their landing page.
 */
export const LandingPages = Object.freeze(
  [
    { permission: Permission.Owner, page: "/surfwize" },
    { permission: Permission.CloudOnlyFilterAdmin, page: "/surfwize" },
    { permission: Permission.FilteringReportingAdmin, page: "/surfwize" },
    { permission: Permission.ReportingViewer, page: "/surfwize" },
    { permission: Permission.ClassroomAdmin, page: "/surfwize" },
    { permission: Permission.ClassroomTechManager, page: "/surfwize" },
    { permission: Permission.FilteringAdmin, page: "/filtering" },
    { permission: Permission.CloudDNSFilterAdmin, page: "/filtering/dns" },
    { permission: Permission.NetworkAdmin, page: "/edgewize" },
    { permission: Permission.CommunityAdmin, page: "/community" },
    { permission: Permission.ConfigurationAdmin, page: "/config" },
    { permission: Permission.GuestConfiguration, page: "/config/device/userdb/guests" },
  ].map((o) => Object.freeze(o))
);

/**
 * Permissions per https://help.linewize.com/hc/en-gb/articles/5765505949852-User-Roles-in-Linewize-Filter
 */
export const ClasswizeConfigPermissions = Object.freeze([
  Permission.Owner,
  Permission.ClassroomAdmin,
  Permission.ClassroomTechManager,
  Permission.CloudOnlyFilterAdmin,
]);

export const RealtimeReportingPermissions = Object.freeze([
  Permission.Owner,
  Permission.FilteringReportingAdmin,
  Permission.ClassroomAdmin,
  Permission.ClassroomTechManager,
]);

export const BypassCodePermissions = Object.freeze([
  Permission.Owner,
  Permission.FilteringAdmin,
  Permission.FilteringReportingAdmin,
  Permission.CloudOnlyFilterAdmin,
]);

export const ConfigAuditPermissions = Object.freeze([Permission.Owner, Permission.CloudOnlyFilterAdmin, Permission.CommunityAdmin]);

export const UserProfilePermissions = Object.freeze([
  Permission.Owner,
  Permission.ConfigurationAdmin,
  Permission.ClassroomAdmin,
  Permission.CloudOnlyFilterAdmin,
]);
